import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "blog-posts" }
const _hoisted_2 = { class: "card text" }
const _hoisted_3 = { class: "card-header bg-color-grey-scale-2 text-1 text-uppercase" }
const _hoisted_4 = { class: "badge badge-success" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "card-title mb-1 text-4 font-weight-bold" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "col-sm-12 text-lg-end my-4 my-lg-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-arrow-right" }, null, -1)
const _hoisted_10 = { class: "card-footer bg-color-grey-scale-2 text-1 text-uppercase" }
const _hoisted_11 = { class: "post-meta" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-pen-to-square" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-folder" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-eye" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import {useCommonStore} from "@/stores/common.store";
import useDateUtils from "@/api/composable/date-utils";
import {onMounted} from "vue";
import useCommonUtils from "@/api/composable/common-utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'Content',
  props: {
  datasets: {
    type: Array,
    default: ()=> []
  }
},
  setup(__props) {

const props = __props;



const commonStore = useCommonStore();
const dateUtils = useDateUtils();
const commonUtils = useCommonUtils();

onMounted(async () => {
  await commonStore.getDataTypeOptions();
  await commonStore.getUpdateFrequencyUnitOptions();
  await commonStore.getDataFormatOptions();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.datasets, (dataset) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: dataset?.dsid
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(" กลุ่มชุดข้อมูล: "),
            _createElementVNode("span", _hoisted_4, _toDisplayString(dataset?.ogroupDto?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, [
              _createElementVNode("a", {
                href: dataset?.name,
                target: "_blank"
              }, _toDisplayString(dataset?.title), 9, _hoisted_7),
              _createTextVNode("  "),
              _createElementVNode("span", {
                class: _normalizeClass(`badge ${_unref(commonUtils).dataFormatClass(dataset?.dataFormat)}`)
              }, _toDisplayString(_unref(commonStore).dataFormatName(dataset?.dataFormat, dataset?.dataFormatOther)), 3)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: `/opendata/${dataset?.id}`,
                class: "mb-1 mt-1 me-1 btn btn-secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("สำรวจ "),
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, [
                _hoisted_12,
                _createTextVNode(" วันที่ปรับปรุงข้อมูลล่าสุด : " + _toDisplayString(_unref(dateUtils).toDateThai(dataset?.lastUpdateDate)), 1)
              ]),
              _createTextVNode("  "),
              _createElementVNode("span", null, [
                _hoisted_13,
                _createTextVNode(" หน่วยความถี่ของการปรับปรุงข้อมูล : " + _toDisplayString(_unref(commonStore).updateFrequencyUnitName(dataset?.updateFrequencyUnit, dataset?.updateFrequencyUnitOther)), 1)
              ]),
              _createTextVNode("  "),
              _createElementVNode("span", null, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_unref(commonStore).dataTypeName(dataset?.dataType)?.name), 1)
              ]),
              _createTextVNode("  "),
              _createElementVNode("span", null, [
                _hoisted_15,
                _createTextVNode(" จำนวนผู้เข้าชม: " + _toDisplayString(_unref(commonUtils).formattedNumber(dataset?.totalViews || 0)), 1)
              ])
            ])
          ])
        ]),
        _hoisted_16
      ], 64))
    }), 128))
  ]))
}
}

})